import { darken, lighten } from 'polished';

export const draculaBg = '#272a35';
export const draculaBorder = '#434759';

export const draculaToolbar = darken(0.1, draculaBorder);

export const draculaIcon = lighten(0.1, '#ffe0ac');
export const draculaIconHover = '#ffe0ac';
